import styled from 'styled-components';
import { Body2, colors, spacing } from 'ui/theme';
import { Tooltip } from 'ui/tooltip';
import { ORG_PERMISSION_NAMES_BY_KEY } from '../../constants';
import { Member } from '../../types';
import { sortedOrgPermissions, permissionsText, roleText } from './utils';

const Wrapper = styled.div`
  align-items: center;
  display: inline-flex;
  gap: ${spacing.half};
`;

const Body2Light = styled(Body2)`
  color: ${colors.textSecondary};
  margin-bottom: 0;
`;

const Underline = styled(Body2Light)`
  text-decoration: ${spacing.single} underline dashed ${colors.textSecondary};
  text-underline-offset: ${spacing.quarter};
`;

const TooltipList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const PageHeaderSubSection = ({ member }: { member: Member }) => {
  const sortedPermissions = sortedOrgPermissions(member);

  return (
    <Wrapper>
      <Body2Light>{member.email}</Body2Light>
      <Body2Light>•</Body2Light>
      <Body2Light>{roleText(member)}</Body2Light>
      <Body2Light>•</Body2Light>
      {sortedPermissions.length > 0 ? (
        <Tooltip
          tooltipContent={
            <TooltipList>
              {sortedPermissions.map((permission: number) => (
                <li key={permission}>
                  {
                    ORG_PERMISSION_NAMES_BY_KEY[
                      permission as keyof typeof ORG_PERMISSION_NAMES_BY_KEY
                    ]
                  }
                </li>
              ))}
            </TooltipList>
          }
        >
          <Underline>{permissionsText(member)}</Underline>
        </Tooltip>
      ) : (
        <Body2Light>0 permissions</Body2Light>
      )}
    </Wrapper>
  );
};
